import request from '@/utils/request'
export function getDynamic(data) {
  return request({
    url: '/app-api/website/dynamic/page',
    method: 'get',
    params: data
  })
}
